import React from 'react';
import { MessageCircle, Send, Clock, Phone } from 'lucide-react';

const CustomerSupport = () => {
  const contactMethods = [
    {
      name: 'WhatsApp',
      icon: MessageCircle,
      description: 'Support rapide via WhatsApp',
      availability: 'Disponible 24/7',
      action: 'Envoyer un message',
      color: 'green',
      link: 'https://t.me/arnelka'
    },
    {
      name: 'Telegram',
      icon: Send,
      description: 'Chattez avec notre équipe',
      availability: 'Réponse en 5 minutes',
      action: 'Ouvrir Telegram',
      color: 'blue',
      link: 'https://t.me/arnelka'
    }
  ];

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white h-screen">
      <div className="text-center mb-12">
        <h2 className="text-3xl font-bold text-gray-800 mb-4">
          Besoin d'aide ?
        </h2>
        <p className="text-lg text-gray-600">
          Notre équipe de support est là pour vous aider
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        {contactMethods.map((method) => (
          <div 
            key={method.name}
            className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
          >
            <div className="p-6">
              <div className="flex items-center mb-4">
                <method.icon 
                  className={`w-8 h-8 text-${method.color}-500 mr-3`}
                />
                <h3 className="text-xl font-semibold text-gray-800">
                  {method.name}
                </h3>
              </div>

              <p className="text-gray-600 mb-4">
                {method.description}
              </p>

              <div className="flex items-center text-gray-500 mb-6">
                <Clock className="w-5 h-5 mr-2" />
                <span className="text-sm">{method.availability}</span>
              </div>

              <a
                href={method.link}
                target="_blank"
                rel="noopener noreferrer"
                className={`inline-flex items-center px-6 py-3 rounded-lg bg-${method.color}-500 hover:bg-${method.color}-600 text-white font-medium transition-colors duration-200`}
              >
                <method.icon className="w-5 h-5 mr-2" />
                {method.action}
              </a>
            </div>
          </div>
        ))}
      </div>

    
    </div>
  );
};

export default CustomerSupport;